import * as React from "react";
import { Outlet, Navigate } from "react-router-dom";
//import { useAuth } from "../../utilities/AuthProvider";
//import Login from "../../pages/Authentication/Login";
import { authGuard } from "../../services/authentication-services";
import Loader from "../Loader/Loader";
import { config } from "../../config/config";
import MaintenanceMessage from "../Maintenance/MaintenanceMessage";

interface PrivateRoutesProps {
  userRole: string;
  multiple: boolean;
}

const PrivateRoutes = ({ userRole, multiple }: PrivateRoutesProps) => {
  const [isAuthenticated, setIsAuthenticated] = React.useState(false);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const userAuth = async () => {
      // If auth is disabled, set loading to false and return
      if (!config.FEATURES.AUTH_ENABLED) {
        setLoading(false);
        return;
      }

      const response = await authGuard(setLoading);
      if (response.status == 200) {
        if (multiple) {
          if (
            response.data.role.toLowerCase() == "user" ||
            response.data.role.toLowerCase() == "lawyer"
          ) {
            setIsAuthenticated(true);
          }
        } else {
          if (response.data.role.toLowerCase() == userRole) {
            setIsAuthenticated(true);
          } else {
            setIsAuthenticated(false);
          }
        }
      } else {
        setIsAuthenticated(false);
      }
    };
    userAuth();
  }, []);

  // Show loader while checking auth
  if (loading) {
    return (
      <div className="z-[1000] flex flex-col items-center justify-center h-[100vh] w-full dark:bg-black bg-white ">
        <Loader color={"blue"} />
        <p className="text-center">Redirecting </p>
      </div>
    );
  }

  // If auth is disabled, show maintenance message
  if (!config.FEATURES.AUTH_ENABLED) {
    return <MaintenanceMessage />;
  }

  // Normal auth flow
  return isAuthenticated ? <Outlet /> : <Navigate to={"/login"} />;
};

export default PrivateRoutes;
